module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/babel-runtime/core-js/symbol.js
// module id = 389
// module chunks = 0